import { render, staticRenderFns } from "./DiscountTagSolid.vue?vue&type=template&id=b512b792&"
import script from "./DiscountTagSolid.vue?vue&type=script&lang=ts&"
export * from "./DiscountTagSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports